// extracted by mini-css-extract-plugin
export default {"brand_product":"Brand_brand_product__9W+mn","status":"Brand_status__DT1oe","action_btn":"Brand_action_btn__zPl8C","competitor":"Brand_competitor__8aSFZ"};